const Home = () =>
{
    return <div>Use the QR code to visit your unique picture.</div>
}

export { Home }